<template>
  <div style="margin-top:20px">
    <el-form ref="form" label-width="80px" :model="form">
      <el-form-item label="字段名称" style="margin-right:15px">
        <el-input v-model="form.fieldName" :disabled="true" />
      </el-form-item>
      <el-form-item label="字段" style="margin-right:15px">
        <el-input v-model="form.fieldValue" :disabled="true" />
      </el-form-item>
      <el-form-item label="是否必填" style="margin-right:15px">
        <el-select
          v-model="form.isRequired"
          placeholder="请选择"
          :disabled="true"
        >
          <el-option label="否" :value="0" />
          <el-option label="是" :value="1" />
        </el-select>
      </el-form-item>
      <el-form-item label="功能模块" style="margin-right:15px">
        <el-select
          v-model="form.fieldFrom"
          placeholder="请选择"
          :disabled="true"
        >
          <el-option label="实际承运人" value="driver" />
          <el-option label="车队" value="driverTeam" />
          <el-option label="托运人" value="shipment" />
          <el-option label="企业托运人" value="shipmentCompany" />
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import request from "@/utils/request";
export default {
  name: "FieldRequiredSettingDetail",
  data() {
    return {
      emptyForm: {},
      form: {
        fieldName: "",
        fieldValue: "",
        isRequired: "",
        fieldFrom: ""
      }
    };
  },
  created() {
    //保存空表单对象
    this.emptyForm = JSON.parse(JSON.stringify(this.form));
  },
  methods: {
    // 获取页面信息
    getInfo(code) {
      //查询到数据之前先展示空表单
      this.form = JSON.parse(JSON.stringify(this.emptyForm));
      request({
        url: `/ntocc-basic-api/fieldRequiredSetting/${code}`,
        method: "get"
      }).then(response => {
        this.form = response.data;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin-top: 50px;
}
</style>
